var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportantIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.986879 14.3538H14.0131C14.7736 14.3538 15.2397 13.5475 14.8717 12.8878L8.34634 1.64858C7.97836 0.988885 7.02163 0.988885 6.65366 1.64858L0.128275 12.8878C-0.239698 13.5231 0.226402 14.3538 0.986879 14.3538ZM7.48773 5.11808C7.90477 5.11808 8.24821 5.46015 8.22368 5.87551L8.10102 10.1513C8.10102 10.4934 7.80664 10.7621 7.48773 10.7621C7.14429 10.7621 6.87445 10.4934 6.87445 10.1513L6.75179 5.87551C6.75179 5.46015 7.0707 5.11808 7.48773 5.11808ZM7.48773 11.2752C7.90477 11.2752 8.24821 11.6173 8.24821 12.0327C8.24821 12.448 7.90477 12.7901 7.48773 12.7901C7.0707 12.7901 6.72726 12.448 6.72726 12.0327C6.72726 11.6417 7.0707 11.2752 7.48773 11.2752Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantIcon);
export default __webpack_public_path__ + "static/media/ImportantIcon.d2115b56.svg";
export { ForwardRef as ReactComponent };